// this is the definions object we get from the backend.
import * as v from 'valibot';
import { deviceStatesSchema } from '../../reducers/device_states';
import { nodeDescriptorSchema } from '../Zigbee/NodeDescriptor';
import { deviceSchema } from '../device';
import { macroSchema } from '../Macro';
import { outletSchema } from '../Outlet';
import { panelSchema } from '../Panel';
import { panelDeviceSchema } from '../PanelDevice';
import { panelGroupSchema } from '../PanelGroup';
import { scheduleSchema } from '../Schedule';
import { zigbeeNodeSchema } from '../Zigbee/ZigbeeNode';
import { hastaReceiverSchema } from '../HastaReceiver';
import { hastaTransmitterSchema } from '../HastaTransmitter';
import { nexaReceiverSchema } from '../NexaReceiver';
import { nexaTransmitterSchema } from '../NexaTransmitter';
import { mandolynSchema } from '../Mandolyn';
import { entitySchema } from '../Entity';
import { actionSchema } from '../Action';
// definitions as sent from the backend
export const backendDefinitionsSchema = v.object({
    actions: v.array(actionSchema),
    entities: v.array(entitySchema),
    outlets: v.array(outletSchema),
    schedules: v.array(scheduleSchema),
    macros: v.array(macroSchema),
    devices: v.array(deviceSchema),
    panels: v.array(panelSchema),
    panel_groups: v.array(panelGroupSchema),
    panel_devices: v.array(panelDeviceSchema),
    zigbee_nodes: v.array(zigbeeNodeSchema),
    zigbee_node_descriptors: v.array(nodeDescriptorSchema),
    device_states: v.optional(deviceStatesSchema),
    hasta_receivers: v.optional(v.array(hastaReceiverSchema), []),
    hasta_transmitters: v.optional(v.array(hastaTransmitterSchema), []),
    nexa_receivers: v.optional(v.array(nexaReceiverSchema), []),
    nexa_transmitters: v.optional(v.array(nexaTransmitterSchema), []),
    mandolyns: v.optional(v.array(mandolynSchema), []),
});
